class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.section-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this._revealTimeout);
        this._revealTimeout = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
      }
    }
    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (!this.headerIsAlwaysSticky) {
      this.header && this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
  }

  reveal() {
    if (!this.headerIsAlwaysSticky) {
      this.header && this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
      this.header && this.header.classList.remove('shopify-section-header-hidden');
    }
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close && disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal && this.searchModal.close && this.searchModal.close();
  }
}

customElements.define('header-drawer', HeaderDrawer);
